import { client } from "../../../../ajax";
import {
  sendingRequest,
  receivedResponse,
  createAction
} from "../../../../redux_util";
import formatError from "../../../../formatErrors";

export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";

export const fetchCategoriesSuccess = createAction(
  FETCH_CATEGORIES_SUCCESS,
  "data"
);

export const fetchCategories = () => {
  return dispatch => {
    dispatch(sendingRequest("fetchCategories"));
    return client
      .get("collections")
      .then(res => {
        dispatch(receivedResponse("fetchCategories"));
        return dispatch(fetchCategoriesSuccess(res.data));
      })
      .catch(err =>
        dispatch(receivedResponse("fetchCategories", formatError(err), "ERROR"))
      );
  };
};



// WEBPACK FOOTER //
// ./src/components/screens/FindCE/redux/actions.js